function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b659b777-7547-4461-b900-ecf8dc120c4b{fill:#fff;}.f4cd8465-6ffb-498a-b8ff-ac7a2c3005a0{fill:#282828;}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "b02636d8-f8b8-4947-9049-2ecfcad6ff4d",
  "data-name": "Ebene 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "bc76af45-53cb-4242-b5b3-d69eda252a05",
  "data-name": "footre"
}, /*#__PURE__*/React.createElement("path", {
  className: "b659b777-7547-4461-b900-ecf8dc120c4b",
  d: "M28.24,8.47a11.29,11.29,0,0,0-11.3,11.29h5.65a5.65,5.65,0,0,1,11.29,0,5.55,5.55,0,0,1-1.66,4l-3.5,3.55a11.35,11.35,0,0,0-3.31,8v1.42h5.65c0-4.24,1.27-5.93,3.3-8l2.54-2.6a9,9,0,0,0,2.63-6.36A11.28,11.28,0,0,0,28.24,8.47Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "b659b777-7547-4461-b900-ecf8dc120c4b",
  x: 25.41,
  y: 42.35,
  width: 5.65,
  height: 5.65
}), /*#__PURE__*/React.createElement("path", {
  className: "f4cd8465-6ffb-498a-b8ff-ac7a2c3005a0",
  d: "M28.24,0A28.24,28.24,0,1,0,56.47,28.24,28.25,28.25,0,0,0,28.24,0ZM25.41,48V42.35h5.65V48ZM36.9,26.12l-2.54,2.6c-2,2.06-3.3,3.75-3.3,8H25.41V35.29a11.35,11.35,0,0,1,3.31-8l3.5-3.55a5.55,5.55,0,0,0,1.66-4,5.65,5.65,0,0,0-11.29,0H16.94a11.3,11.3,0,0,1,22.59,0A9,9,0,0,1,36.9,26.12Z"
})));

const SvgHelp = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 56.47 56.47",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHelp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/help.8d791e55.svg";
export { ForwardRef as ReactComponent };